<template>
  <div id="home">

    <div class="scrollView"  @scroll="elementScroll($event)">

      <img v-if="specsub_imgthumb" :src="specsub_imgthumb" class="bg_img">
      <div class="desc" v-if="desc" v-html="desc"></div>

      <div class="news-list-item tapable_el"  v-for="(item,item_index) in list" @click.stop="openContent(item)" tapmode  >
        <div class="news-list-item-title  text-overflow"  v-html="item.title"></div>
        <div class="news-list-item-bigimg" >
          <img v-if="item.thumb"  @error="setdefaultImg($event)" v-lazy="item.thumb+'?x-oss-process=image/resize,m_lfit,h_470,w_800'" class="news-list-item-bigimg-img">
        </div>
      </div>
      <!-- loading-->
      <div v-if="showloading && !loadend" class="bottom-loading">
        <van-loading size="24px">加载中...</van-loading>
      </div>

    </div>


    <div class="c-loading" v-if="loading">
      <div class="c-loading-c">
        <img src="../assets/loading.svg">
        <div>加载中...</div>
      </div>

    </div>

  </div>
</template>
<style >
  .scrollView{ max-width: 640px; margin: auto}
  .toplink{ position: relative; z-index: 100}
  header{ display: flex; justify-content: space-between; align-items: center; height: 60px; font-size: 16px; color: #222222;text-align: center;
     padding-right: 15px; box-sizing: border-box; border-bottom: 0.5px solid #eaeaea;
  }
  .back img{ height: 18px; display: block}


  .header-start,.header-end{ display: flex;align-items: center; width: 80px;}

  .header-end{ justify-content: flex-end;height: 20px}
  #home{ height: 100vh;position: fixed; width: 100%; left: 0; top:0; display: flex; flex-direction: column}


  .header{ position: fixed; width: 100%; left: 0; top:0; background-color: #fff;z-index: 1000;}
  .bg_img{ width: 100%}
  header .text-overflow-one{width: 60%;text-align: center;}

  .labels_warp{ width: 100%; height: 40px; padding: 0 15px;border-bottom: 0.3px solid #eaeaea;}
  .labels_cont{ width: 100% ;display: flex}
  .labels_item{ height: 40px; line-height: 40px; padding: 0 15px; font-size: 16px; color: #3e3e3e}
  .labels_item.active{color: red}
  .back2{ position: fixed; left:0; top:0; z-index: 1; height: 75px;  display: flex;  align-items: center }
  .back2 .back2-warp{ display: flex; justify-content: center; align-items: center;width: 50px; height: 50px;}
  .back2  img{height: 18px; display: block}
  .back2-warp div{display: flex; justify-content: center; align-items: center; width: 30px; height: 30px; border-radius: 50%; }
  .noimghead{ width: 100%; height: 60px}
  .is_spec{ display: none !important;}
  .desc{ padding:15px 40px;color: #626262; font-size: 14px; line-height: 26px;letter-spacing: 1.5px; background-image: url("../assets/icon-yinhao@2x.png"); background-repeat: no-repeat; background-position: 15px 15px; background-size: 16px; border-bottom: 5px solid #f4f5f7}


</style>
<script>
  //app滚动广告更多
  import { ImagePreview } from 'vant';
// @ is an alias to /src
import leftImg from '@/components/leftImg.vue'
  import rightImg from '@/components/rightImg.vue'
  import onelyTxt from '@/components/onelyTxt.vue'
  import bigImgDesc from '@/components/bigImgDesc.vue'
  import newsVideoItem from '@/components/newsVideoItem.vue'
  import bigImg from '@/components/bigImg.vue'
  import threeImg from '@/components/threeImg.vue'






  import request from "../utils/request";
  import utils from "../utils";

export default {
  name: 'SpecialList',
  components: {
    leftImg,
    rightImg,
    onelyTxt,
    bigImgDesc,
    newsVideoItem,
    bigImg,
    threeImg
  },
  data: function(){
    return {
      show_no_internet: false,

      hide: false,
      list: [],
      page: 1,
      showloading: true,
      loadend: false,
      scrolltop: 0,
      title:"列表",
      specsub_imgthumb:"",
      header_opactiy:1,
      loading:true,
      desc:""
    }
  },

  created: function created() {
    this.show = true;
    this.getdata();
    // var data = {"code":200,"message":"成功","data":[{"pv_num":28447,"pv_quantity":28447,"uv_num":0,"live_status":0,"ad_scroll":[],"ad_code":"资讯","art_id":225561,"cat_id":11,"spec_id":225453,"title":"落实防疫责任100问⑧ | 企业如何更好地履行“四方责任”？","type":4,"author":"神鸟知讯","art_link":"","is_spec":1,"desc":"求证新闻真相","praise_num":468,"praise_quantity":468,"comment_num":0,"read_money":"0.00","thumb":["http://img2.yitoutiao.net/news/202203290054156241e83775ac2.jpg"],"thumb_num":1,"banner_thumb":"","resource":"","is_stick":0,"is_stick_especially":0,"is_top":0,"publish_time":"2022-03-29 00:52:46","labels":0,"is_public":0,"public_id":0,"voice_pth_man":"","voice_pth_girl":"","voice_sch_girl":"","voice_yy":"","sort_time":1648486366,"from_user_id":0,"com_list":[],"format_time":"","voice_status":0,"voice_last":"","voice_next":""},{"pv_num":36888,"pv_quantity":36888,"uv_num":0,"live_status":0,"ad_scroll":[],"ad_code":"资讯","art_id":225560,"cat_id":11,"spec_id":225453,"title":"落实防疫责任100问⑦ | “首席健康官”是个什么“官”？","type":4,"author":"神鸟知讯","art_link":"","is_spec":1,"desc":"求证新闻真相","praise_num":37,"praise_quantity":37,"comment_num":0,"read_money":"0.00","thumb":["http://img2.yitoutiao.net/news/202203290050046241e73cb940f.png"],"thumb_num":1,"banner_thumb":"","resource":"","is_stick":0,"is_stick_especially":0,"is_top":0,"publish_time":"2022-03-29 00:49:56","labels":0,"is_public":0,"public_id":0,"voice_pth_man":"","voice_pth_girl":"","voice_sch_girl":"","voice_yy":"","sort_time":1648486196,"from_user_id":0,"com_list":[],"format_time":"","voice_status":0,"voice_last":"","voice_next":""},{"pv_num":71483,"pv_quantity":71483,"uv_num":0,"live_status":0,"ad_scroll":[],"ad_code":"资讯","art_id":225486,"cat_id":11,"spec_id":225453,"title":"落实防疫责任100问 | ⑥ 消毒，你做对了吗？","type":1,"author":"神鸟知讯","art_link":"","is_spec":1,"desc":"求证新闻真相","praise_num":13,"praise_quantity":13,"comment_num":0,"read_money":"0.00","thumb":["http://img2.yitoutiao.net/news/2022032816090662416d22dbf96.png"],"thumb_num":1,"banner_thumb":"","resource":"","is_stick":0,"is_stick_especially":0,"is_top":0,"publish_time":"2022-03-28 16:03:29","labels":0,"is_public":0,"public_id":0,"voice_pth_man":"","voice_pth_girl":"","voice_sch_girl":"","voice_yy":"","sort_time":1648454609,"from_user_id":0,"format_time":"","voice_status":0,"voice_last":"","voice_next":""},{"pv_num":56111,"pv_quantity":56111,"uv_num":0,"live_status":0,"ad_scroll":[],"ad_code":"资讯","art_id":225481,"cat_id":11,"spec_id":225453,"title":"落实防疫责任100问 | ⑤  疫情防控总关“心”！如何克服焦虑、愤怒等常见心理问题？","type":1,"author":"神鸟知讯","art_link":"","is_spec":1,"desc":"求证新闻真相","praise_num":226,"praise_quantity":226,"comment_num":0,"read_money":"0.00","thumb":["http://img2.yitoutiao.net/news/20220328155533624169f505325.png"],"thumb_num":1,"banner_thumb":"","resource":"","is_stick":0,"is_stick_especially":0,"is_top":0,"publish_time":"2022-03-28 15:46:15","labels":0,"is_public":0,"public_id":0,"voice_pth_man":"","voice_pth_girl":"","voice_sch_girl":"","voice_yy":"","sort_time":1648453575,"from_user_id":0,"format_time":"","voice_status":0,"voice_last":"","voice_next":""},{"pv_num":63014,"pv_quantity":63014,"uv_num":0,"live_status":0,"ad_scroll":[],"ad_code":"资讯","art_id":225474,"cat_id":11,"spec_id":225453,"title":"落实防疫责任100问 | ④ 如何居家医学观察？有哪些注意事项？","type":1,"author":"神鸟知讯","art_link":"","is_spec":1,"desc":"求证新闻真相","praise_num":361,"praise_quantity":361,"comment_num":0,"read_money":"0.00","thumb":["http://img2.yitoutiao.net/news/2022032815122662415fda7fcc5.jpg"],"thumb_num":1,"banner_thumb":"","resource":"","is_stick":0,"is_stick_especially":0,"is_top":0,"publish_time":"2022-03-28 15:04:45","labels":0,"is_public":0,"public_id":0,"voice_pth_man":"","voice_pth_girl":"","voice_sch_girl":"","voice_yy":"","sort_time":1648451085,"from_user_id":0,"format_time":"","voice_status":0,"voice_last":"","voice_next":""},{"pv_num":77328,"pv_quantity":77328,"uv_num":0,"live_status":0,"ad_scroll":[],"ad_code":"资讯","art_id":225468,"cat_id":11,"spec_id":225453,"title":"落实防疫责任100问 | ③ 如何应对小区封闭式管理？","type":1,"author":"神鸟知讯","art_link":"","is_spec":1,"desc":"求证新闻真相","praise_num":154,"praise_quantity":154,"comment_num":0,"read_money":"0.00","thumb":["http://img2.yitoutiao.net/news/2022032814553062415be2ba91e.png"],"thumb_num":1,"banner_thumb":"","resource":"","is_stick":0,"is_stick_especially":0,"is_top":0,"publish_time":"2022-03-28 14:47:03","labels":0,"is_public":0,"public_id":0,"voice_pth_man":"","voice_pth_girl":"","voice_sch_girl":"","voice_yy":"","sort_time":1648450023,"from_user_id":0,"format_time":"","voice_status":0,"voice_last":"","voice_next":""},{"pv_num":72558,"pv_quantity":72558,"uv_num":0,"live_status":0,"ad_scroll":[],"ad_code":"资讯","art_id":225455,"cat_id":11,"spec_id":225453,"title":"落实防疫责任100问 | ② 办公场所人员相对密集，应注意哪些防疫要点？","type":1,"author":"神鸟知讯","art_link":"","is_spec":1,"desc":"求证新闻真相","praise_num":391,"praise_quantity":391,"comment_num":0,"read_money":"0.00","thumb":["http://img2.yitoutiao.net/news/202203281415306241528252fce.png"],"thumb_num":1,"banner_thumb":"","resource":"","is_stick":0,"is_stick_especially":0,"is_top":0,"publish_time":"2022-03-28 13:59:19","labels":0,"is_public":0,"public_id":0,"voice_pth_man":"","voice_pth_girl":"","voice_sch_girl":"","voice_yy":"","sort_time":1648447159,"from_user_id":0,"format_time":"","voice_status":0,"voice_last":"","voice_next":""},{"pv_num":53392,"pv_quantity":53392,"uv_num":0,"live_status":0,"ad_scroll":[],"ad_code":"资讯","art_id":225454,"cat_id":11,"spec_id":225453,"title":"落实防疫责任100问 | ① 高校学子如何科学防疫？","type":1,"author":"神鸟知讯","art_link":"","is_spec":1,"desc":"求证新闻真相","praise_num":407,"praise_quantity":407,"comment_num":0,"read_money":"0.00","thumb":["http://img2.yitoutiao.net/news/2022032813585662414ea06ae94.png"],"thumb_num":1,"banner_thumb":"","resource":"","is_stick":0,"is_stick_especially":0,"is_top":0,"publish_time":"2022-03-28 13:58:15","labels":0,"is_public":0,"public_id":0,"voice_pth_man":"","voice_pth_girl":"","voice_sch_girl":"","voice_yy":"","sort_time":1648447095,"from_user_id":0,"format_time":"","voice_status":0,"voice_last":"","voice_next":""}],"title":"企业如何更好地履行“四方责任”？","banner_thumb":""}
    //
    // this.list = data.data;
    // this.title = data.title;

  },
  mounted() {
    document.querySelector(".toplink").style.display = 'none'
  },
  methods: {

    TextAreaText2Html: function TextAreaText2Html(str) {
      if (!str) {
        return "";
      }
      var reg = /\n/gim;
      var reg1 = /\r/gim;
      var reg3 = /\n\r/gim;
      var reg4 = /\s/gim;
      str = str.replace(reg3, "<br/>");
      str = str.replace(reg, "<br/>");
      str = str.replace(reg1, "<br/>");
      str = str.replace(reg4, "&nbsp;");

      return str;
    },
    setdefaultImg: function setdefaultImg(event) {
      var el = event.currentTarget;
      el.style.opacity = 0;
    },
    //获取数据
    getdata: function getdata() {
      var _this = this;


      var page = this.page;
      request.scrollAdContent(this.$route.params.id,  function (res, err) {

        _this.loading = false;
        if(!res.data.banner_thumb){
          _this.header_opactiy =1
        }else{
          _this.specsub_imgthumb = res.data.banner_thumb
        }
        if (err) {
          _this.show_no_internet = true;
          _this.showloading = false;
          return;
        }

        if (res && res.code == 200) {
          if(res.data.title){
            document.title = res.data.title;
          }

            _this.title = res.data.title;
           _this.list = res.data.ad_scroll;


          if(res.data.title){
            request.getWeixinShanre(location.href,(s_res)=>{
              let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
              let shareconfig = {appId,timestamp,nonceStr,signature};
              if(utils.is_weixin()){
                if(res.data.title){
                  let sharedata = {
                    title:res.data.title?res.data.title:"看度时政",
                    desc:res.data.desc,
                    link:location.href,
                    imgUrl:thumb
                  };
                  utils.setWeiXinShare(sharedata,shareconfig,false)
                }

              }
            });
          }
          if(res.data.desc && res.data.desc !=="求证新闻真相"){
            _this.desc = _this.TextAreaText2Html(res.data.desc)

          }
          _this.show_no_internet = true;
          _this.showloading = false;

        }
      });
    },
    elementScroll: function elementScroll(e) {
      var _this2 = this;

      this.scrolltop = e.target.scrollTop; //滚动到了底部

      if(this.specsub_imgthumb){
        var opactiy = e.target.scrollTop/100;
        if(opactiy<0){
          opactiy = 0
        }else if(opactiy>1){
          opactiy = 1
        }
        this.header_opactiy = opactiy;
      }
      if (this.scrollbottom) {
        var topheight = e.target.offsetHeight + e.target.scrollTop;

        if (topheight + 30 >= e.target.scrollHeight && this.lastscroll < e.target.scrollTop) {
          if (this.scrollTopTimeOut) {
            clearTimeout(this.scrollTopTimeOut);
            this.scrollTopTimeOut = false;
          }

          this.scrollTopTimeOut = setTimeout(function () {
            _this2.scrollbottom();
          }, 300);
        }

        this.lastscroll = e.target.scrollTop;
      }
    },
    scrollbottom: function scrollbottom() {
      //this.getdata();
    },
    openContent(item){
      if (item.art_link) {
        utils.openPage(item,this)
      } else {
        this.$router.push({name: "NewsContent", params: {id: item.art_id}})
      }
    }
  }
}
</script>
